var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_vm._v("\n    このページにアクセスする権限がありません。管理者に権限を追加してもらう必要があります。\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }